

























import {Component, Prop, Vue} from 'vue-property-decorator';
import ServiceContainer from '@flashpointbv/solar-service-container';
import {enhancedEcommerce} from '../../../shared/helpers/enhanced-ecommerce';

@Component(
  {
    name: 'catalog-product-configuration',
    components: ServiceContainer().getComponents(),
  }
)

export default class extends Vue {
  @Prop({default: 'field'}) private readonly qtyType: string;
  @Prop({default: false}) private readonly enableTooltip: boolean;
  @Prop({default: 1}) private qtyIncrement: number;
  @Prop({default: false}) private readonly isOnWishlist: boolean;

  @Prop() private readonly productData: object;
  @Prop() private readonly productBundleData: { selections: {}[] }[];

  protected qty: number = 1;
  private addToCartIsLoading: boolean = false;
  private addedToCart: boolean = false;
  private addToCartErrorMessage: string = '';
  private wishlistToggle: boolean = false;

  private get addToCartButtonText(): string {
    if (this.productData['frontend_stock'] <= 0 && this.productData['not_saleable'] === true) {
      return this.$t('Temporarily out of order').toString();
    }
    return this.isOutOfStock ? this.$t('Order with longer delivery time').toString() : this.$t('In winkelwagen').toString();
  }

  private get isSaleable(): boolean {
    if (this.productData['frontend_stock'] <= 0 && this.productData['not_saleable'] === true) {
      return false;
    }
    return this.$store.getters['CatalogProduct/isSaleable'] && (this.productData['in_stock'] || !this.productData['manage_stock']);
  }

  private get isOutOfStock(): boolean {
    if (this.productData['product_type'] === 'bundle') {
      return this.productData['bundle_is_backorder'];
    } else {
      return !this.productData['delivery_in_stock'];
    }
  }

  private get productQty(): number {
    const maxQty = 25;
    if (0 < this.productData['frontend_stock']
      && maxQty > this.productData['frontend_stock']
      && true === this.productData['sale_stock_only']
    ) {
      return this.productData['frontend_stock'];
    }

    return maxQty;
  }

  private get selectedOptions(): Array<object> {
    return this.$store.getters['CatalogConfigurableProduct/selectedOptions'];
  }

  private changeQty(a): void {
    if (typeof this.qty !== 'string' && this.qty > 0) {
      this.qty = a === '+' ? (this.qty + this.qtyIncrement) : a === '-' && this.qty > 0 ? (this.qty - this.qtyIncrement) : (Math.ceil(this.qty / this.qtyIncrement) * this.qtyIncrement);
    } else {
      this.qty = 1;
    }
  }

  private async productAddToCart(): Promise<void> {
    this.addToCartIsLoading = true;

    try {
      let productPayload = {
        sku: this.productData['sku'],
        qty: this.qty,
      };

      if (this.productData['product_type'] === 'configurable' && this.selectedOptions.length > 0) {
        const productOptions = {
          product_option: {
            extension_attributes: {
              configurable_item_options: this.selectedOptions.map(option => {
                return {
                  option_id: option['attributeId'],
                  option_value: option['selectedValue']
                }
              })
            }
          }
        }
        productPayload = Object.assign(productPayload, productOptions);
      }

      await this.$store.dispatch('CheckoutCart/addProductToQuote', productPayload);

      await this.$store.dispatch(
        'MeasurementProtocol/fireGaEvent', {
          event: 'add_to_cart',
          data: {
            product: this.productData,
            qty: 1,
          }
        }
      );

      this.addedToCart = true;
      this.resetAddedToCart();
      enhancedEcommerce.addProductAddToCart(this.productData, this.qty);

    } catch (e) {
      const response = e.response.data;

      this.addToCartErrorMessage = response.message;
    } finally {
      this.addToCartIsLoading = false;
    }
  }

  private resetAddedToCart(): void {
    setTimeout(() => {
      this.addedToCart = false;
    }, 3000);
  }

  private async toggleWishlist(): Promise<void> {
    try {
      await this.$store.dispatch('CustomerWishlist/toggleWishlistProduct', this.productData['product_id']);
      await this.$store.dispatch('CustomerWishlist/updateWishlistCount', !this.wishlistToggle);
      this.wishlistToggle = !this.wishlistToggle;
    } catch (e) {
      console.log(e);
    }
  }

  private created(): void {
    this.wishlistToggle = this.isOnWishlist;
    this.$store.dispatch('CatalogProduct/getProductData', this.productData);
    if (this.productBundleData.length > 0) {
      this.$store.dispatch('CatalogBundleProduct/getAvailableOptions', this.productBundleData);
    }
    enhancedEcommerce.addProductDetail(this.productData);
    window.dispatchEvent(new Event('rrinit'));
  }
}
